/**
 * Common functionality module
 * Provides shared utilities used across the site
 */

// Clipboard feedback duration
const CLIPBOARD_FEEDBACK_DURATION = 3000;

export default class common {
  constructor() {
    this.setScrollbarFunc();
    this.initClipboard();
  }
  setScrollbarFunc() {
    document.documentElement.style.setProperty('--scrollbar', `0px`);

    const setScrollbarWidth = () => {
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty(
        '--scrollbar',
        `${scrollbarWidth}px`
      );
    };

    setScrollbarWidth();
    window.addEventListener('resize', setScrollbarWidth);
  }

  /**
   * Copy to clipboard functionality with visual feedback
   */
  initClipboard() {
    const copyButtons = document.querySelectorAll('.clipButton');

    copyButtons.forEach(button => {
      button.addEventListener('click', async function () {
        const copyText = this.nextElementSibling?.textContent;

        if (!copyText) return;

        try {
          await navigator.clipboard.writeText(copyText);
          button.classList.add('is-clicked');

          setTimeout(() => {
            button.classList.remove('is-clicked');
          }, CLIPBOARD_FEEDBACK_DURATION);
        } catch (error) {
          console.error('[Clipboard] Failed to copy:', error);
        }
      });
    });
  }
}
